
let envConfig = {};
let selectedProject =   {
  id: 18,
  type: 2,
  multiLangStatus: false,


  name: "Türkiye Giyinme Kimliği Platformu",
  color1: "#004f9f",
  color2: "#3396d1",
  color3: "#ed1c24",
  color4: "#c9bd68",
 // projectLogo: "/uploads/projectLogo/2.png",
 // mainPageImage: require("./images/atam/2x.png"),
  // './../../images/ttk/atam2.png',

  inst: "AKM",
  instLongName: "Atatürk Kültür Merkezi Başkanlığı",
  instUrl:"https://www.akm.gov.tr",

//   social: {
//     facebook: "https://www.facebook.com/Akm.Baskanlik", 
//     youtube: "https://www.youtube.com/user/atambaskanlik",
//     instagram: "https://www.instagram.com/atambaskanlik/",
//     twitter: "https://x.com/AtamBaskanlik",
//   },
  contact: {
    address: "Üniversiteler Mah. Toplum Cad. No.: 5 06800 Çankaya/ANKARA",
    mail: "bilgi@akmb.gov.tr",
    tel: "0312 123 45 67",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6121.620271096461!2d32.741316!3d39.900883!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d347862c84861d%3A0x822c27404f3450bf!2zQXRhdMO8cmsgS8O8bHTDvHIsIERpbCB2ZSBUYXJpaCBZw7xrc2VrIEt1cnVtdQ!5e0!3m2!1sen!2str!4v1723707914855!5m2!1sen!2str" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'},
  tag: true,
  whoContributed: true,
  workingGroup: true,


  tagInfo: {
    isbn : "978-975-17-4677-1",
    yayinNo : 487,
    eserAdi : "Türk Dünyası Ansiklopedisi",
    yayimci : "Atatürk Araştırma Merkezi Başkanlığı",
    yayimciMarkaAdi : "Atatürk Kültür Dil ve Tarih Yüksek Kurumu – Atatürk Araştırma Merkezi Başkanlığı",
    yayinlandigiOrtamTuru : "Elektronik Materyal",
    yayinlandigiOrtam:"Elektronik Kapak (Çevrim içi / Web tabanlı)",
    ortamTuru : "http / https",
    erisimeAcilmaTarihi : "29.10.2020",
    erisimAdresi:"www.ataturkansiklopedisi.gov.tr",
    erisimTuru : "Open Access"
  },


};


export {selectedProject};

const devConfig = {
  //apiUrl: "http://localhost:3325",
  // userAuthApiUrl: "http://localhost:3301",
  // userCheckApiUrl: "http://localhost:3301/v1/user/check/otherApp",
   apiUrl: "https://apiko.ayk.gov.tr",
  //userAuthApiUrl: "http://192.168.55.66:3301",
  userCheckApiUrl: "https://testgiris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://giris.ayk.gov.tr/api/",
  mainPageUrl: "http://localhost:3000/",
  appUrl:"http://localhost:3005",
  sendItemUrl: "http://localhost:3004/says/sendItemPage/",
  adviceItemUrl: "http://localhost:3004/says/adviceItemPage/",

};
const testConfig = {
  apiUrl: "https://testsays.ayk.gov.tr/api/",
  mainPageUrl: "https://testgiris.ayk.gov.tr/",
  userCheckApiUrl: "https://testgiris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://testgiris.ayk.gov.tr/api/",
  appUrl:"https://testsozluk.ttk.gov.tr",
  sendItemUrl: "https://testsays.ayk.gov.tr/says/sendItemPage/",
  adviceItemUrl: "https://testsays.ayk.gov.tr/says/adviceItemPage/",

};
const prodConfig = {
  apiUrl: "https://apiko.ayk.gov.tr",
  mainPageUrl: "https://giris.ayk.gov.tr/",
  userCheckApiUrl: "https://giris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://giris.ayk.gov.tr/api/",
  appUrl:"https://tugikip.gov.tr",
  sendItemUrl: "https://says.ayk.gov.tr/says/sendItemPage/",
  adviceItemUrl: "https://says.ayk.gov.tr/says/adviceItemPage/",

};
if (process.env.REACT_APP_ENV === "development") {
  envConfig = devConfig;
} else if (process.env.REACT_APP_ENV === "test") {
  envConfig = testConfig;
} else if (process.env.REACT_APP_ENV === "production") {
  envConfig = prodConfig;
}


const config =  {
  apiUrl: envConfig.apiUrl,
  mainPageUrl: envConfig.mainPageUrl, 
  userCheckApiUrl: envConfig.userCheckApiUrl,
  userAuthApiUrl: envConfig.userAuthApiUrl, 
  appUrl: envConfig.appUrl,
  sendItemUrl : envConfig.sendItemUrl,
  adviceItemUrl : envConfig.adviceItemUrl,

  project:selectedProject,

 
  defaultProfileImageUrl: "/images/user.jpg",

  copright: "Her hakkı saklıdır. Türk Dil Kurumu",
  coprightYear: "2023",



  alphabet : [ 'A', 'B', 'C','Ç', 'D', 'E', 'F', 'G','Ğ', 'H', 'I','İ', 'J', 'K', 'L', 'M', 'N', 'O','Ö', 'P',  'R',  'S','Ş', 'T', 'U','Ü' ,'V', 'Y', 'Z' ],
  numbers: [ 0,1,2,3,4,5,6,7,8,9 ],

  institutions: [
    {
      id: 1,
        inst: "TDK",
      instLongName: "Türk Dil Kurumu",
      instLong: "Türk Dil Kurumu'nun",
      messages: ""
    },
    { 
      id: 2,
      inst: "TTK",
      instLongName: "Türk Tarih Kurumu",
      instLong: "Türk Tarih Kurumu'nun",
      messages: "Evrakı ıslak imzalı olarak (2 Adet) MNG Kargo ile Kurum adına alıcı ödemeli olarak 108814424 müşteri kodu ile gönderebilirsiniz. Alıcı:Serkan KARTAL Tel: 0312 310 23 68 / 134",
    },
    {
      id: 3,
      inst: "ATAM",
      instLongName: "Atatürk Araştırma Merkezi Başkanlığı",
      instLong: "Atatürk Araştırma Merkezi Başkanlığı'nın",
      messages: "",
    },
    {
      id: 4,
      inst: "AKM",
      instLongName: "Atatürk Kültür Merkezi Başkanlığı",
      instLong: "Atatürk Kültür Merkezi Başkanlığı'nın",
      messages: "",
    },
  ],

};

export default config;
